import styled from "@emotion/styled";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const Root = styled.div(props => ({
    lineHeight: theme(props).reactUISizes.input.height.css(),
    textAlign: "center",
    color: theme(props).icons.color,
    cursor: "pointer",

    ":hover": {
        backgroundColor: theme(props).keyPalette.panelBackgroundColor,
        color: theme(props).icons.hoverBackgroundColor,
    },
}));
